import FormJaivana from "dashboard_jaivana_v1";
/**
 * @description: CustomAdministrarConteo
 * @author: Anderson Acevedo Briñez
 * @version: jdesk_1.01.0009.8
 **/
class CustomAdministrarConteo extends FormJaivana.form {
  constructor(props) {
    super(props);
    this.initForm                          = this.initForm.bind(this);
    this.gridOptionsTablaTerceros2                           = Object.assign({}, this.gridOptions);
    this.onSelectionChanged                                 = this.onSelectionChanged.bind(this);
    this.gridOptionsTablaTerceros2['onSelectionChanged']         = this.onSelectionChanged;

    this.refrescarTablaPrincipal   =   this.refrescarTablaPrincipal.bind(this);
    this.llenarTabla   =   this.llenarTabla.bind(this);
    this.sucessTraerEncabezado   =   this.sucessTraerEncabezado.bind(this);
    this.setButtonAccion   =   this.setButtonAccion.bind(this);

    this.onSelectionChangedConteo  = this.onSelectionChangedConteo.bind(this);
    this.gridOptionsItemsConteo                         = Object.assign({}, this.gridOptions);
    this.gridOptionsItemsConteo['onSelectionChanged']         = this.onSelectionChangedConteo;

    this.cantidadtablaChange  = this.cantidadtablaChange.bind(this);
    this.refrescarTabla  = this.refrescarTabla.bind(this);
    this.successTraerEstadoEmpaques  = this.successTraerEstadoEmpaques.bind(this);
    this.traerEstadoEmpaque  = this.traerEstadoEmpaque.bind(this);
    this.cerrarPedidoConteo  = this.cerrarPedidoConteo.bind(this);
    this.successcerrarPedidoConteo  = this.successcerrarPedidoConteo.bind(this);
    this.contarTodo  = this.contarTodo.bind(this);
    this.successtraerCantidadesItems  = this.successtraerCantidadesItems.bind(this);
    this.traerCantidadesItems  = this.traerCantidadesItems.bind(this);

    this.currencyFormatterGeneral                           = this.currencyFormatterGeneral.bind(this);
    this.formatNumberSaldo                                  = this.formatNumberSaldo.bind(this);
    this.mostrarMensajeGenerando  = this.mostrarMensajeGenerando.bind(this);
    this.mostrarMensajeGuardando  = this.mostrarMensajeGuardando.bind(this);
    this.mostrarMensajeAdicional  = this.mostrarMensajeAdicional.bind(this);
    this.ajustarTabla  = this.ajustarTabla.bind(this);

    this.array_cantidades=[];
    this.datos_contados=[];
    this.array_aux=[];

    this.codigo_sucursal ='';


  }

  initForm() {
    console.log("Formulario CustomAdministrarConteo,  @version: jdesk_1.01.0009.8, @author: Anderson Acevedo Briñez");
    this.codigo_sucursal = JSON.parse(localStorage.getItem('sucursal_ingreso')).codigo_sucursal;
    
    this.ajustarTabla();
    this.refrescarTablaPrincipal();
    this.getField('btn_refrescar').setClick(this.refrescarTablaPrincipal)


    //modal conteo
    this.getField('bt_contar_todo').setClick(this.contarTodo);
    this.getField('bt_traer_wms').setClick(this.traerEstadoEmpaque);
    this.getField('bt_enviar_caja').setClick(this.cerrarPedidoConteo);
  }

    ajustarTabla(){
      //para ajustar los anchos ya que la primera vez que se muestra
      //no los ajusta bien
        let row={
            
      };
      let arr=[];
      arr.push(row);

      let configCell = new Map();
      
      this.gridOptionsTablaTerceros2['rowData'] = arr;
      this.getField('tabla_pedidos_conteo').initData(this.gridOptionsTablaTerceros2, configCell);

    }

    refrescarTablaPrincipal() {
        this.mostrarMensajeGenerando();
        this.getField('btn_refrescar').setDisabled(true);
        this.arrayNuevo = [];
        let datos={ datos: {
            codigo_sucursal:this.codigo_sucursal
        }};
        this.generalFormatPmv = { tipo_servicio: 'most-administrarconteo', operacion: 'encabezadoconteo', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.sucessTraerEncabezado,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    onSelectionChanged(){

    }


    sucessTraerEncabezado(data) { 
      this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {

            this.arrayPendientes = data.data; // almacenar el valor del primer servicio en un array global
            this.susccessRespuestaSegundoServ(data);
            
        }else{
            this.getField('tabla_pedidos_conteo').toggle(false);
            this.getField('btn_refrescar').setDisabled(false);
        }
        this.refrescando_tabla=false;
    }

    
    susccessRespuestaSegundoServ(data) {
        if (data.estado_p === 200) {

            this.arrayPendientes.forEach((item) => {

                let objetoNuevo = {
                    numero_pedido: item.numero_pedido,
                    nombre_cliente: item.nombre,
                    documento: item.nit,
                    sede: item.sede,
                    id: item.nitsx_sedes_id,
                    total: item.sum,
                    tipo_pedido: item.tipo_pedido,
                    fecha: item.fecha_sistema,
                    codigo_usuario: item.codigo
                }

                /*data.data.forEach((item2) => {
                    if(item.nitsx_sedes_id === item2.nitsx_sedes_id){
                        objetoNuevo['codigo_usuario'] = item2.codigo;
                        objetoNuevo['fecha'] = item2.fecha_sistema;
                    }
                });*/
                this.arrayNuevo.push(objetoNuevo);

            });
            let data1 = {
                "data" : this.arrayNuevo,
                "estado_p": data.estado_p
            };

            this.llenarTabla(data1);

        }else{
            this.getField('tabla_pedidos_conteo').toggle(false);
        }
    }

    llenarTabla(data) {

        this.getField('btn_refrescar').setDisabled(false);
        
        this.contDevolver = 0;
        this.arrayIdsEliminar = 0;

        this.getField('confirmModalCustom').toggle(false);
        if ((data.estado_p === 200 ) && (data.data[0].total > 0)) { 
           
          //numero_pedido,codigo_usuario,nombre_cliente,documento,sede,fecha,total,tipo_pedido,accion

            let configCell = new Map();
            configCell.set('nombre_cliente', { width: 233});

            
            configCell.set('total', {  cellRenderer: (props) => { return '' + this.currencyFormatterGeneral(props.data.total) }, type: 'rightAligned' });
            configCell.set('sede', {  type: 'rightAligned' });
            configCell.set('accion', { cellRenderer: this.setButtonAccion, width: 110, sortable: false, filter: false});

            this.gridOptionsTablaTerceros2['rowData'] = data.data;
            this.getField('tabla_pedidos_conteo').initData(this.gridOptionsTablaTerceros2, configCell);
        }


    }

  setButtonAccion(props) {
    let id = props.data.activosfijos_id;
    let button = document.createElement("input");
    button.onclick = () => this.traerCantidadesItems(props);
    
    button.setAttribute("id", 'button_delete_' + id);
    button.setAttribute("class", "buttonStyle");
    button.setAttribute("type", "button");
    button.setAttribute("value", "Contar");
    return this.createElementJaivana(button);
  }


   //toda esta funcionalidad se va a pasar a otro formulario.
    traerCantidadesItems(props){
        this.mostrarMensajeGenerando(); 
        this.props_temp=props;
        let datos={ datos: {
            codigo_sucursal: this.codigo_sucursal,   
            numero_pedido: this.props_temp.data.numero_pedido+'',
        }};
        this.generalFormatPmv = { tipo_servicio: 'most-listaclientes', operacion: 'traercantidades', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successtraerCantidadesItems,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    successtraerCantidadesItems(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) { 
                this.array_cantidades=data.data.items_cantidades;
                this.getField('modal_items_conteo').handleClickOpen();
                this.refrescarTabla();
        } else { 
            this.alertGeneral.toggle(true,data.data.mensaje,"error");
        }
    }

    onSelectionChangedConteo() {

    }

    cerrarPedidoConteo(){
        //se valida si todos los productos del pedidos
        //ya fueron registrados en el wms
        this.array_aux=[];
        let contados=0;
        for(let i=0;i<this.array_cantidades.length;i++){
            this.array_aux.push({
                codigo:this.array_cantidades[i].codigo,
                cantidad:this.array_cantidades[i].cantidad_contada,
                bodega:this.array_cantidades[i].bodega,
            })
            contados+=this.array_cantidades[i].cantidad_contada;
        }

        //valida si se conto alemnos una unidad
        if(contados>0){
          let datos = { datos: {
                  codigo_sucursal: this.codigo_sucursal,
                  numero_pedido: this.props_temp.data.numero_pedido,
                  estado: 'A',
                  items: this.array_aux,
              }
          }; 
          this.generalFormatPmv = { tipo_servicio: 'most-listaclientes', operacion: 'cerrarpedidoconteo', operacion_tipo: 'modificar' };
          
          this.service.send(
              {
                  endpoint: this.constant.formConfiguration(),
                  method: 'GET',
                  body: datos,
                  success: this.successcerrarPedidoConteo,
                  error: this.error_,
                  general: this.generalFormatPmv,
                  showMessage: false
          });
        }else{
           this.alertGeneral.toggle(true, 'Es necesario haber contado al menos una unidad.' , 'error');
        }
          
    }

    successcerrarPedidoConteo(data){
        if (data.estado_p === 200) {
            if(data.data.errores !== null && data.data.errores !== undefined && data.data.errores.mensaje !== null && data.data.errores.mensaje !== undefined){
                this.getField('confirmModalCustom').setTitleAndContent('Cerrar Pedido', data.data.errores.mensaje)
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setClickDialog(()=>{
                    this.getField('confirmModalCustom').toggle(false);
                    this.refrescarTablaPrincipal();
                });
                this.getField("confirmModalCustom").setButtonConfirm(`Aceptar`); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField("confirmModalCustom").setButtonCancel("Cancelar")
                this.getField('confirmModalCustom').toggle(true); 
            }else if(data.data.mensaje!==undefined){
                
                this.getField('confirmModalCustom').setTitleAndContent('Cerrar Pedido', data.data.mensaje)
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setClickDialog(()=>{
                    this.getField('confirmModalCustom').toggle(false);
                    this.getField('modal_items_conteo').handleClose();
                    this.refrescarTablaPrincipal();
                });
                this.getField("confirmModalCustom").setButtonConfirm(`Aceptar`); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField("confirmModalCustom").setButtonCancel("Cancelar")
                this.getField('confirmModalCustom').toggle(true); 
            }else{
                this.getField('modal_items_conteo').handleClose();
                this.refrescarTablaPrincipal();
            }
        }else {
            if(data.data.errores !== null && data.data.errores !== undefined){
                let mensaje='No se puede guardar se presentaron los siguientes errores : ';

                let values=Object.values(data.data.errores)
                for(let i=0;i<values.length;i++){
                    mensaje+= values[i];
                    if(i<values.length)
                        mensaje+=' ';
                }
                this.mostrarMensajeAdicional(mensaje);
            }else{
                this.alertGeneral.toggle(true, data.data.errores , 'error');
            }
        }
    }

    traerEstadoEmpaque(){
        //se valida si todos los productos del pedidos
        //ya fueron registrados en el wms
        this.mostrarMensajeGenerando();
        let datos = { datos: {
                codigo_sucursal: this.codigo_sucursal,
                numero_pedido: this.props_temp.data.numero_pedido+'',
            }
        }; 
        this.generalFormatPmv = { tipo_servicio: 'most-listaclientes', operacion: 'estadoempaque', operacion_tipo: 'consultar' };
        
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.successTraerEstadoEmpaques,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
        });
    }

    successTraerEstadoEmpaques(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            if(data.data.errores !== null && data.data.errores !== undefined && data.data.errores.mensaje !== null && data.data.errores.mensaje !== undefined){
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje', data.data.errores.mensaje)
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setClickDialog(()=>{
                    this.getField('confirmModalCustom').toggle(false);
                });
                this.getField("confirmModalCustom").setButtonConfirm(`Aceptar`); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField("confirmModalCustom").setButtonCancel("Cancelar")
                this.getField('confirmModalCustom').toggle(true); 
            }
            this.getField('modal_items_conteo').handleClickOpen();
            this.datos_contados=data.data.items;
            //llenar items
            this.array_cantidades.forEach((element,index)=>{
                for(let i=0;i<this.datos_contados.length;i++){
                    if(element.codigo===this.datos_contados.codigo){
                        this.array_cantidades[index].cantidad_contada=this.datos_contados[i].cantidad;
                    }
                }
                if(index===this.datos_contados.length-1)
                    this.refrescarTabla();
            });
        }else {
            if(data.data.errores !== null && data.data.errores !== undefined && data.data.errores.mensaje !== null && data.data.errores.mensaje !== undefined){
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje', data.data.errores.mensaje)
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setClickDialog(()=>{
                    this.getField('confirmModalCustom').toggle(false);
                });
                this.getField("confirmModalCustom").setButtonConfirm(`Aceptar`); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField("confirmModalCustom").setButtonCancel("Cancelar")
                this.getField('confirmModalCustom').toggle(true); 
            }else{
                this.alertGeneral.toggle(true, data.data.errores , 'error');
            }
        }
    }

    refrescarTabla(){
        let configCell = new Map();
        this.gridOptionsItemsConteo['rowData'] = this.array_cantidades;
        configCell.set('cantidad_pedida', { cellRenderer: function (props) { return props.data.cantidad_pedida }, cellStyle: { textAlign: "right" }});
        configCell.set('cantidad_contada', { cellRenderer: function (props) { return props.data.cantidad_contada }, cellStyle: { backgroundColor: "rgb(238,238,238)", textAlign: "right", borderRadius: "5px", color: 'rgb(0, 86, 201)' }, editable: true, onCellValueChanged: this.cantidadtablaChange, sortable: true, filter: false});

        this.getField('items_conteo').initData(this.gridOptionsItemsConteo,configCell);
    }

    cantidadtablaChange(props) {
        let seguir = this.getField('items_conteo').cellValid(props.oldValue, props.newValue, /^(\d{1,13})(\.\d{0,2})?$/,16);


        if (isNaN(props.data.cantidad_contada) || seguir===false) {
            if(!seguir){
                this.getField('confirmModalCustom').setTitleAndContent('Formato Incorrecto', `La columna cantidad no tiene un formato correspondiente al tipo (Numérico 13,2)`);
                this.getField('confirmModalCustom').setClickDialog(() => {this.getField('confirmModalCustom').toggle(false); });
                this.getField("confirmModalCustom").setVisibleCancel(true);
                this.getField("confirmModalCustom").setButtonConfirm(`Ok`);
                this.getField('confirmModalCustom').toggle(true);
            }else if(props.newValue<0 && props.newValue>10000000000 ){
                this.getField('confirmModalCustom').setTitleAndContent('Formato Incorrecto', `El valor debe estar entre las longitudes (0.00,10000000000.00)`);
                this.getField('confirmModalCustom').setClickDialog(() => {this.getField('confirmModalCustom').toggle(false); });
                this.getField("confirmModalCustom").setVisibleCancel(true);
                this.getField("confirmModalCustom").setButtonConfirm(`Ok`);
                this.getField('confirmModalCustom').toggle(true);
            }
            this.array_cantidades.forEach((element,index)=>{
                if(element.codigo===props.data.codigo){
                    this.array_cantidades[index].cantidad_contada=props.oldValue;
                }
                if(index===this.array_cantidades.length-1)
                    this.refrescarTabla();
            });
        }else if(seguir){     
            if(props.newValue<0 || props.newValue>10000000000 ){
                this.getField('confirmModalCustom').setTitleAndContent('Formato Incorrecto', `El valor debe estar entre las longitudes (0.00,10000000000.00)`);
                this.getField('confirmModalCustom').setClickDialog(() => {
                    this.getField('confirmModalCustom').toggle(false); 
                    this.array_cantidades.forEach((element,index)=>{
                         if(element.codigo===props.data.codigo){
                            this.array_cantidades[index].cantidad_contada=props.oldValue;
                        }
                        if(index===this.array_cantidades.length-1)
                            this.refrescarTabla();
                    });
                });
                this.getField("confirmModalCustom").setVisibleCancel(true);
                this.getField("confirmModalCustom").setButtonConfirm(`Ok`);
                this.getField('confirmModalCustom').toggle(true);
            } 
            //nada
        }
    }


    contarTodo() {
        //setea la columna candidad_empacada 
        //con el valor de cantidad (pedidos_almacen);

        this.array_cantidades.forEach((element,index)=>{
            this.array_cantidades[index].cantidad_contada=this.array_cantidades[index].cantidad_pedida;
                
            if(index===this.array_cantidades.length-1)
                this.refrescarTabla();
        });


    }

    currencyFormatterGeneral(number) {
        let decimal = (number + "").split(".")[1];//para manejar los decimales
        if ((decimal !== 0) && (decimal !== undefined)) {
            if (decimal.length > 2) {
                decimal = (Number(number).toFixed(2) + "").split(".")[1];
            }
            return (this.formatNumberSaldo(number) + "," + decimal);
        } else {
            return this.formatNumberSaldo(number);
        }
    }

    formatNumberSaldo(number) {
        return Number(number).toString().split('.')[0]
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }

    mostrarMensajeGenerando(){
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
        this.getField('confirmModalCustom').setClickDialog(()=>{});  
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeGuardando() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está guardando la información... `);
        this.getField('confirmModalCustom').setClickDialog(() => { });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeAdicional(mensaje){
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', mensaje);
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    
 

   
}

FormJaivana.addController("most-administrarconteo", CustomAdministrarConteo);
export default CustomAdministrarConteo;